import { Gift } from "lucide-react";
import { toast } from "sonner";

const HOLIDAYS = ["01-01", "01-06", "04-25", "05-01", "06-02", "08-15", "11-01", "12-08", "12-25", "12-26"];

const easterMonday = (y) => {
  const a = y % 19, b = Math.floor(y / 100), c = y % 100;
  const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  const dt = new Date(Date.UTC(y, month - 1, day));
  dt.setUTCDate(dt.getUTCDate() + 1);
  return dt.toISOString().slice(0, 10);
};

const deliveryDateError = (value) => {
  if (!value) return null;
  const d = new Date(value + "T12:00:00");
  if (d.getDay() === 0) return "Non consegniamo la domenica: scegli un altro giorno";
  if (HOLIDAYS.includes(value.slice(5)) || value === easterMonday(d.getFullYear()))
    return "Il giorno scelto è festivo: scegli un altro giorno";
  return null;
};

const FIELDS = [
  { key: "name", label: "Nome e cognome", req: true, span: 2 },
  { key: "email", label: "Email", req: true, type: "email", span: 2 },
  { key: "phone", label: "Telefono", req: false, span: 2 },
  { key: "address", label: "Indirizzo", req: true, span: 2 },
  { key: "city", label: "Città", req: true },
  { key: "cap", label: "CAP", req: true },
  { key: "province", label: "Provincia", req: false },
];

export const CheckoutFields = ({ form, setForm, minDate }) => {
  const onDateChange = (e) => {
    const v = e.target.value;
    const err = deliveryDateError(v);
    if (err) {
      toast.error(err);
      setForm({ ...form, delivery_date: "" });
    } else {
      setForm({ ...form, delivery_date: v });
    }
  };

  return (
    <>
      {FIELDS.map((f) => (
        <div key={f.key} className={f.span === 2 ? "col-span-2" : "col-span-1"}>
          <label className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#78716C] block mb-2">
            {f.label} {f.req && <span className="text-[#2E8A57]">*</span>}
          </label>
          <input
            data-testid={`checkout-${f.key}-input`}
            type={f.type || "text"}
            required={f.req}
            value={form[f.key]}
            onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
            className="w-full rounded-xl border border-[#E7E0D8] bg-white px-4 py-3.5 text-sm focus:outline-none focus:border-[#2E8A57] transition-colors"
          />
        </div>
      ))}
      <div className="col-span-2 sm:col-span-1">
        <label className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#78716C] block mb-2">
          Giorno di consegna preferito <span className="text-[#2E8A57]">*</span>
        </label>
        <input
          data-testid="checkout-delivery-date-input"
          type="date"
          required
          min={minDate}
          value={form.delivery_date}
          onChange={onDateChange}
          className="w-full rounded-xl border border-[#E7E0D8] bg-white px-4 py-3.5 text-sm focus:outline-none focus:border-[#2E8A57] transition-colors"
        />
        <p className="mt-1.5 text-[11px] text-[#78716C]">Minimo 2 giorni · no domeniche e festivi</p>
      </div>
      <div className="col-span-2 rounded-2xl border border-[#E7E0D8] bg-[#FBF6EC] p-5">
        <label className="flex items-center gap-3 cursor-pointer">
          <input
            data-testid="checkout-gift-toggle"
            type="checkbox"
            checked={form.gift}
            onChange={(e) => setForm({ ...form, gift: e.target.checked })}
            className="w-5 h-5 accent-[#2E8A57]"
          />
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-[#1C1917]">
            <Gift className="w-4 h-4 text-[#B4831A]" /> Questo ordine è un regalo
          </span>
        </label>
        {form.gift && (
          <div className="mt-4 space-y-4">
            <div>
              <label className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#78716C] block mb-2">Da parte di</label>
              <input
                data-testid="checkout-gift-from-input"
                maxLength={60}
                value={form.gift_from}
                onChange={(e) => setForm({ ...form, gift_from: e.target.value })}
                placeholder="Il tuo nome"
                className="w-full rounded-xl border border-[#E7E0D8] bg-white px-4 py-3.5 text-sm focus:outline-none focus:border-[#2E8A57] transition-colors"
              />
            </div>
            <div>
              <label className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#78716C] block mb-2">Biglietto personalizzato</label>
              <textarea
                data-testid="checkout-gift-message-input"
                rows={3}
                maxLength={300}
                value={form.gift_message}
                onChange={(e) => setForm({ ...form, gift_message: e.target.value })}
                placeholder="Scrivi il messaggio che stamperemo sul biglietto incluso nel box..."
                className="w-full rounded-xl border border-[#E7E0D8] bg-white px-4 py-3.5 text-sm focus:outline-none focus:border-[#2E8A57] transition-colors"
              />
              <p className="mt-1 text-[11px] text-[#78716C] text-right">{form.gift_message.length}/300</p>
            </div>
            <p className="text-xs text-[#78716C]">Inserisci qui sopra nome e indirizzo del <strong>destinatario</strong>: il pacco arriverà a lui, con il tuo biglietto e senza prezzi.</p>
          </div>
        )}
      </div>
      <div className="col-span-2">
        <label className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#78716C] block mb-2">Note per la consegna</label>
        <textarea
          data-testid="checkout-notes-input"
          rows={3}
          value={form.notes}
          onChange={(e) => setForm({ ...form, notes: e.target.value })}
          className="w-full rounded-xl border border-[#E7E0D8] bg-white px-4 py-3.5 text-sm focus:outline-none focus:border-[#2E8A57] transition-colors"
        />
      </div>
    </>
  );
};
